import * as layerOps from '../api/Layers/layer-operations';

import loadAnnotationsTable from './load-annotations-table';

import loadCSVTable from './load-csv-table';
import loadExcelFromURL from './load-excel-from-url';
import loadFiwareTable from './load-fiware-table';
import loadGeoJSONTable from './load-geojson-table';
import loadMapBoxTable from './load-mapbox-table';
import loadPostgreSQLTable from './load-postgresql-table';
import loadTMSTable from './load-tms-table';
import loadWMSTable from './load-wms-table';

const COMING_SOON = 'ComingSoon';

/**
 * Fetches the thematic layer, by layerSubType, and returns the two arrays needed for the table.
 *
 * @async
 * @param {string} layer - The thematic layer.
 * @returns {object} An object containing the two arrays needed for the table.
 * @throws {Error} If something goes wrong.
 */
const loadTableLayer = async layer => {
  try {
    let tableTitle = [];
    let tableBody = [];
    let coordinates = [];
    let type = [];

    switch (true) {
      case layerOps.isCSV(layer):
        ({ tableBody, tableTitle } = await loadCSVTable(layer));
        break;
      case layerOps.isGeoJSON(layer):
      case layerOps.isGeoJSONVT(layer):
      case layerOps.isIndoor(layer):
      case layerOps.isJoin(layer):
      case layerOps.isOGR(layer):
      case layerOps.isRealTime(layer):
      case layerOps.isTopoJSON(layer):
        ({ coordinates, tableBody, tableTitle, type } = await loadGeoJSONTable(layer));
        break;
      case layerOps.isPostgreSQL(layer):
        ({ tableBody, tableTitle } = await loadPostgreSQLTable(layer));
        break;
      case layerOps.isFiware(layer):
        ({ tableBody, tableTitle } = await loadFiwareTable(layer));
        break;
      case layerOps.isMapBox(layer):
        ({ tableBody, tableTitle } = await loadMapBoxTable(layer));
        break;
      case layerOps.isWMS(layer):
        ({ tableBody, tableTitle } = await loadWMSTable(layer));
        break;
      case layerOps.isTMS(layer):
        ({ tableBody, tableTitle } = await loadTMSTable(layer));
        break;
      case layerOps.isExcel(layer):
      case layerOps.isGoogleSheets(layer):
        ({ tableBody, tableTitle } = await loadExcelFromURL(layer));
        break;
      case layerOps.isGeoImage(layer):
        tableTitle.push(COMING_SOON);
        break;
      case layerOps.isAnnotationsLayer(layer):
      case layerOps.isAnnotationsRealTime(layer):
        ({ tableBody, tableTitle, coordinates } = await loadAnnotationsTable(layer));
        break;

      default:
        break;
    }
    return { coordinates, tableBody, tableTitle, type };
  } catch (err) {
    throw new Error(err.message);
  }
};

export default loadTableLayer;
